import React, { Component } from "react"

import { Container, Row } from "react-bootstrap"

import IceCream1 from "../../../images/flavours/Ananas.png"
import IceCream2 from "../../../images/flavours/Aprikose.png"
import IceCream3 from "../../../images/flavours/Banane.png"
import IceCream4 from "../../../images/flavours/Blutorange.png"
import IceCream5 from "../../../images/flavours/Bubble-Gum-(Schlumpf,-Engelblau).png"
import IceCream6 from "../../../images/flavours/Caramel.png"
import IceCream7 from "../../../images/flavours/Cherry.png"
import IceCream8 from "../../../images/flavours/Cookies.png"
import IceCream9 from "../../../images/flavours/Crocciantino-(Rum-Krokant).png"
import IceCream10 from "../../../images/flavours/Dolce-Latte.png"

import IceCream11 from "../../../images/flavours/Durian.png"
import IceCream12 from "../../../images/flavours/Erdbeere.png"
import IceCream13 from "../../../images/flavours/Haselnuss.png"
import IceCream14 from "../../../images/flavours/Heidelbeere.png"
import IceCream15 from "../../../images/flavours/Himbeere.png"
import IceCream16 from "../../../images/flavours/Jackfrucht.png"
import IceCream17 from "../../../images/flavours/Joghurt-Kirsch.png"
import IceCream18 from "../../../images/flavours/Kaffee-(Cappuccino).png"
import IceCream19 from "../../../images/flavours/Kinderschokolade.png"
import IceCream20 from "../../../images/flavours/Kirsche.png"

import IceCream21 from "../../../images/flavours/Kokos.png"
import IceCream22 from "../../../images/flavours/Litschi.png"
import IceCream23 from "../../../images/flavours/Malaga.png"
import IceCream24 from "../../../images/flavours/Mango.png"
import IceCream25 from "../../../images/flavours/Melone.png"
import IceCream26 from "../../../images/flavours/Menta.png"
import IceCream27 from "../../../images/flavours/Nougat.png"
import IceCream28 from "../../../images/flavours/Panna-Cotta.png"
import IceCream29 from "../../../images/flavours/Papaya.png"
import IceCream30 from "../../../images/flavours/Pfirsich.png"

import IceCream31 from "../../../images/flavours/Schokolade.png"
import IceCream32 from "../../../images/flavours/Stracciatella.png"
import IceCream33 from "../../../images/flavours/Tiramisu.png"
import IceCream34 from "../../../images/flavours/Vanille.png"
import IceCream35 from "../../../images/flavours/Waldmeister.png"
import IceCream36 from "../../../images/flavours/Wallnuss.png"
import IceCream37 from "../../../images/flavours/Weisse-Schokolade.png"
import IceCream38 from "../../../images/flavours/Zimt-(mit-Pflaume).png"
import IceCream39 from "../../../images/flavours/Zitrone.png"
import IceCream40 from "../../../images/flavours/Zuppa-Inglese-(Eierpunsch).png"

import LeftArrow from "../../../images/arrow-left.svg"
import RightArrow from "../../../images/arrow-right.svg"

import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import "./carouselnew.scss"

export default class CarouselNew extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }
  next() {
    this.slider.slickNext()
  }
  previous() {
    this.slider.slickPrev()
  }

  componentDidMount() {
    var viewportWidth =
      window.innerWidth || document.documentElement.clientWidth

    if (viewportWidth < 1021) {
      var elem = document.querySelector(".currenstlidespan")
      elem.innerHTML = 1
    }
  }
  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1020,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false,
          },
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
      ],

      afterChange: function (idkey) {
        //currenstlidespan

        if (window.innerWidth > 1019) {
          var elem = document.querySelector(".currenstlidespan")

          if (idkey == 0) {
            elem.innerHTML = 5
          } else if (idkey === 5) {
            elem.innerHTML = 10
            //elem.innerHTML = (idkey);
          } else if (idkey === 10) {
            elem.innerHTML = 15
            //elem.innerHTML = (idkey);
          } else if (idkey === 15) {
            elem.innerHTML = 20
            //elem.innerHTML = (idkey);
          } else if (idkey === 20) {
            elem.innerHTML = 25
            //elem.innerHTML = (idkey);
          } else if (idkey === 25) {
            elem.innerHTML = 30
            //elem.innerHTML = (idkey);
          } else if (idkey === 30) {
            elem.innerHTML = 35
            //elem.innerHTML = (idkey);
          } else if (idkey === 35) {
            elem.innerHTML = 40
            //elem.innerHTML = (idkey);
          }
        } else {
          var elem = document.querySelector(".currenstlidespan")
          elem.innerHTML = idkey + 1
        }
      },
    }
    return (
      <div className="custom-slider1">
        <Slider ref={c => (this.slider = c)} {...settings}>
          <div>
            <div>
              <img src={IceCream1} className="flavor" alt="Ananas" />
              <div className="first-bckg">Ananas</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream2} className="flavor" alt="Aprikose" />
              <div className="first-bckg">Aprikose</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream3} className="flavor" alt="Banane" />
              <div className="first-bckg">Banane</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream4} className="flavor" alt="Blutorange" />
              <div className="first-bckg">Blutorange</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream5} className="flavor" alt="Bubble-Gum" />
              <div className="first-bckg">Bubble-Gum</div>
            </div>
          </div>

          <div>
            <div>
              <img src={IceCream6} className="flavor" alt="Caramel" />
              <div className="first-bckg">Caramel</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream7} className="flavor" alt="Cherry" />
              <div className="first-bckg">Cherry</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream8} className="flavor" alt="Cookies" />
              <div className="first-bckg">Cookies</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream9} className="flavor" alt="Crocciantino" />
              <div className="first-bckg">Crocciantino</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream10} className="flavor" alt="Dolce-Latte" />
              <div className="first-bckg">Dolce-Latte</div>
            </div>
          </div>

          <div>
            <div>
              <img src={IceCream11} className="flavor" alt="Durian" />
              <div className="first-bckg">Durian</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream12} className="flavor" alt="Erdbeere" />
              <div className="first-bckg">Erdbeere</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream13} className="flavor" alt="Haselnuss" />
              <div className="first-bckg">Haselnuss</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream14} className="flavor" alt="Heidelbeere" />
              <div className="first-bckg">Heidelbeere</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream15} className="flavor" alt="Himbeere" />
              <div className="first-bckg">Himbeere</div>
            </div>
          </div>

          <div>
            <div>
              <img src={IceCream16} className="flavor" alt="Jackfrucht" />
              <div className="first-bckg">Jackfrucht</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream17} className="flavor" alt="Joghurt-Kirsch" />
              <div className="first-bckg">Joghurt-Kirsch</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream18} className="flavor" alt="Kaffee" />
              <div className="first-bckg">Kaffee</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream19} className="flavor" alt="Kinderschokolade" />
              <div className="first-bckg smaller-font">Kinderschokolade</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream20} className="flavor" alt="Kirsche" />
              <div className="first-bckg">Kirsche</div>
            </div>
          </div>

          <div>
            <div>
              <img src={IceCream21} className="flavor" alt="Kokos" />
              <div className="first-bckg">Kokos</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream22} className="flavor" alt="Litschi" />
              <div className="first-bckg">Litschi</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream23} className="flavor" alt="Malaga" />
              <div className="first-bckg">Malaga</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream24} className="flavor" alt="Mango" />
              <div className="first-bckg">Mango</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream25} className="flavor" alt="Melone" />
              <div className="first-bckg">Melone</div>
            </div>
          </div>

          <div>
            <div>
              <img src={IceCream26} className="flavor" alt="Menta" />
              <div className="first-bckg">Menta</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream27} className="flavor" alt="Nougat" />
              <div className="first-bckg">Nougat</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream28} className="flavor" alt="Panna-Cotta" />
              <div className="first-bckg">Panna-Cotta</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream29} className="flavor" alt="Papaya" />
              <div className="first-bckg">Papaya</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream30} className="flavor" alt="Pfirsich" />
              <div className="first-bckg">Pfirsich</div>
            </div>
          </div>

          <div>
            <div>
              <img src={IceCream31} className="flavor" alt="Schokolade" />
              <div className="first-bckg">Schokolade</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream32} className="flavor" alt="Stracciatella" />
              <div className="first-bckg">Stracciatella</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream33} className="flavor" alt="Tiramisu" />
              <div className="first-bckg">Tiramisu</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream34} className="flavor" alt="Vanille" />
              <div className="first-bckg">Vanille</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream35} className="flavor" alt="Waldmeister" />
              <div className="first-bckg">Waldmeister</div>
            </div>
          </div>

          <div>
            <div>
              <img src={IceCream36} className="flavor" alt="Wallnuss" />
              <div className="first-bckg">Wallnuss</div>
            </div>
          </div>
          <div>
            <div>
              <img
                src={IceCream37}
                className="flavor"
                alt="Weisse-Schokolade"
              />
              <div className="first-bckg smaller-font">Weisse-Schokolade</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream38} className="flavor" alt="Zimt" />
              <div className="first-bckg">Zimt</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream39} className="flavor" alt="Zitrone" />
              <div className="first-bckg">Zitrone</div>
            </div>
          </div>
          <div>
            <div>
              <img src={IceCream40} className="flavor" alt="Zuppa-Inglese" />
              <div className="first-bckg">Zuppa-Inglese</div>
            </div>
          </div>
        </Slider>
        <Container>
          <Row className="justify-content-md-center next-previous-wrap">
            <div className="back-button-wrap">
              <div className="back-button" onClick={this.previous}>
                <span className="back-button-arrow">
                  <img src={LeftArrow} />
                </span>
                <span className="button-text-mid_left">Zurück</span>
              </div>
            </div>
            <div>
              <p className="no-margin-mob">
                <span className="currenstlidespan">5</span>{" "}
                <span className="slash">/</span>{" "}
                <span className="totalslidecount">40</span>
              </p>
            </div>
            <div className="back-button-wrap">
              <div className="next-button" onClick={this.next}>
                <span className="button-text-mid_right">Weiter</span>
                <span className="next-button-arrow">
                  <img src={RightArrow} />
                </span>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    )
  }
}
